(ns frontend.view.modals.ratings.deal
  (:require
   [ui.util :as uu]
   [common.localization :as loc]
   [common.entity :as entity]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.radix-ui.avatar.view :as avatar]))

(defonce modal-key :ratings-modal)

(defn ratings-stars-view
  [_]
  (let [temp-value (r/atom nil)
        set-temp-value! (fn [v]
                          (reset! temp-value v))]
    (fn [{:keys [state value step scale account on-change!]}]
      [:div
       {:class "flex gap-1"}
       (doall
        (for [i scale]
          (let [saved-value (get value (:db/id account))
                changed-value @temp-value
                star-value (* i step)
                dimmed? (if changed-value
                          (and (< changed-value star-value)
                               (> star-value saved-value))
                          (< saved-value star-value))
                is-lower? (and changed-value
                               (>= changed-value star-value)
                               (< changed-value saved-value))]
            [:i
             {:key            i
              :class          (uu/cm (cond dimmed?
                                     "fal"
                                     is-lower?
                                     "fad"
                                     :else
                                     "fas")
                               "fa-star text-base-light-text cursor-pointer")
              :on-mouse-over  (partial set-temp-value! (* i step))
              :on-mouse-leave (partial set-temp-value! nil)
              :on-click       (fn []
                                (let [v (* i step)]
                                  (swap! state assoc (:db/id account) v)
                                  (on-change! (assoc value (:db/id account) v))))}])))])))

(defn ratings-view
  [{:keys [state value accounts step scale on-change!]}]
  [:div
   {:class "flex flex-col"}
   (doall (for [account accounts]
            [:div
             {:class "py-2 flex justify-between items-center gap-3
                      border-b border-solid border-base-light-border-paler last:border-b-0"
              :key   (:db/id account)}
             [avatar/view 
              {:image-url (:account/picture-url account)
               :fallback  (entity/get-initials account)
               :size :small
               :font-size :small}]
              [:div
               {:class "flex-1 text-semibold"}
               [:span
                (entity/get-first-name account)]
               [:span (entity/get-last-name account)]]

             [ratings-stars-view
              {:state      state
               :value      value
               :step       step
               :scale      scale
               :on-change! on-change!
               :account    account}]]))])

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [label value accounts step scale on-change! on-submit! set-edit! show-buttons?]} props]
    [modal/view
     {:visible? (and shown? topmost?)
      :hide!    close-modal!
      :backdrop "static"}
     label
     [ratings-view
      {:state      state
       :value      (merge value @state)
       :accounts   accounts
       :step       step
       :scale      scale
       :on-change! on-change!}]
     [modal/footer-children-left-and-right
      [[button/secondary-hollow
        {:on-click (fn [_]
                     (close-modal!))}
        (loc/tr :cancel)]]
      [[button/primary-solid
        {:disabled? (empty? @state)
         :on-click  (fn [_]
                      (on-submit! (merge value @state))
                      (close-modal!))}
        (loc/tr :submit)]]
      ]]))
